import { render, staticRenderFns } from "./DeleteSection.vue?vue&type=template&id=43081596&"
import script from "./DeleteSection.vue?vue&type=script&lang=js&"
export * from "./DeleteSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports